import { render, staticRenderFns } from "./addproductwizard.vue?vue&type=template&id=ce006dc8&scoped=true&"
import script from "./addproductwizard.vue?vue&type=script&lang=js&"
export * from "./addproductwizard.vue?vue&type=script&lang=js&"
import style0 from "./addproductwizard.vue?vue&type=style&index=0&id=ce006dc8&lang=scss&"
import style1 from "./addproductwizard.vue?vue&type=style&index=1&id=ce006dc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce006dc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce006dc8')) {
      api.createRecord('ce006dc8', component.options)
    } else {
      api.reload('ce006dc8', component.options)
    }
    module.hot.accept("./addproductwizard.vue?vue&type=template&id=ce006dc8&scoped=true&", function () {
      api.rerender('ce006dc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inventory/products/AddProduct/addproductwizard.vue"
export default component.exports